var $413f5c9b05a53d70$exports = {};
$413f5c9b05a53d70$exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "placeholder": `Vybrat\u{2026}`
};


export {$413f5c9b05a53d70$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
